import React from 'react';
import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { IJournalResponseInput, IToggleOptions, QuestionOptions } from '../../../../global/entities/Journal/Journal';

interface ToggleQuestionProps {
    questionId: number;
    response: IJournalResponseInput | undefined;
    onResponseChange: (questionId: number, updates: Partial<IJournalResponseInput>) => void;
    options?: QuestionOptions | null;
    currentLang: 'en' | 'fr';
    readOnly?: boolean;
}

export const ToggleQuestion: React.FC<ToggleQuestionProps> = ({
    questionId,
    response,
    onResponseChange,
    options,
    currentLang,
    readOnly = false,
}) => {
    const { t } = useTranslation();

    const toggleOptions = options as IToggleOptions | undefined;
    const isActive = response?.responseValue === 'on';

    const label = isActive
        ? (currentLang === 'fr' ? toggleOptions?.labelFr : toggleOptions?.labelEn) || t('journal.toggleOn')
        : (currentLang === 'fr' ? toggleOptions?.labelFr : toggleOptions?.labelEn) || t('journal.toggleOff');

    const handleClick = () => {
        if (readOnly) return;
        onResponseChange(questionId, {
            responseValue: isActive ? '' : 'on',
        });
    };

    return (
        <Button
            variant={isActive ? 'filled' : 'outline'}
            color={isActive ? 'blue' : 'gray'}
            onClick={handleClick}
        >
            {label}
        </Button>
    );
};
